import React from 'react';
import { Sprite } from '@inlet/react-pixi';
import { generatePath } from 'react-router-dom';

import { useNonDragClick } from '../../hooks/useNonDragClick';
import { GamePositionModel } from '../../models/gamePositionModel';
import { Routes } from '../../routes';

interface Props {
  worldWidth: number;
  worldHeight: number;
  gamePosition: GamePositionModel;
  islandId: string;
  onHistoryPush: (route: string, state?: unknown) => void;
}

const GameLink = ({
  worldWidth, worldHeight, gamePosition, islandId, onHistoryPush,
}: Props): React.ReactElement => {
  const {
    game: {
      id,
      thumbnailUrl,
    },
    thumbnailHeightPercentage,
    thumbnailWidthPercentage,
    percentageOffsetX,
    percentageOffsetY,
  } = gamePosition;
  const wordWrapWidth = (worldWidth * thumbnailWidthPercentage) / 100;
  const containerHeight = (worldWidth * thumbnailHeightPercentage) / 100;

  const xSignOffset = (worldWidth * percentageOffsetX) / 100;
  const ySignOffset = (worldHeight * percentageOffsetY) / 100;

  const onIntendedClick = () => {
    /**
     * Go to the game page
     */
    onHistoryPush(generatePath(Routes.Islands.Games.View, {
      islandId,
      gameId: id,
    }));
  };

  const [onPointerDown, onPointerUp] = useNonDragClick();

  return (
    <Sprite
      image={thumbnailUrl}
      x={xSignOffset}
      y={ySignOffset}
      width={wordWrapWidth}
      height={containerHeight}
      pointerdown={onPointerDown}
      pointerup={(event) => onPointerUp(event, () => onIntendedClick())}
      anchor={0.5}
      cursor="pointer"
      interactive
    />
  );
};

export default GameLink;
